import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo-old.png'


const _withScopeId = n => (_pushScopeId("data-v-04ad2d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "v1 logo",
  class: "header-logo",
  src: _imports_0
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-title" }, "第一视频举报中心", -1))
const _hoisted_3 = {
  key: 0,
  class: "main-content"
}
const _hoisted_4 = { class: "success-page" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-message" }, "信息提交成功", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success-text" }, "感谢你对净化网络环境做出的贡献,谢谢你的支持", -1))
const _hoisted_7 = {
  key: 1,
  class: "main-content"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "举报人基本信息", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "举报信息", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 最多上传3个文件；单个文件最大不可大于30M。 ", -1))
const _hoisted_11 = { class: "footer-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://v.v1.cn/v1group/founder.html"
  }, "创始人")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.liepin.com/company/9113901/"
  }, "加入我们")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "http://www.12377.cn/"
  }, "廉洁举报")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://v.v1.cn/Qualification/privacy.html"
  }, "隐私政策")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Copyright ©2005-2022 第一视频公司版权所有 "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "http://beian.miit.gov.cn"
  }, "京ICP备10014938号-4")
], -1))

import { reactive, ref } from 'vue'
    import type { FormInstance, FormRules } from 'element-plus'
    import { ElMessage, ElMessageBox } from 'element-plus'
    import type { UploadProps, UploadUserFile } from 'element-plus'

    import { getCaptchaCode, saveReport } from '@/api/jubao'
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

    let saveSuccess = ref(false)
    const formSize = ref('large')
    const ruleFormRef = ref<FormInstance>()
    const ruleForm = reactive({
        realname: '',
        email: '',
        type: '',
        phone: '',
        link: '',
        content: '',
        code: '',
        imgUUID: '',
    })

    const rules = reactive<FormRules>({
        realname: [
            { required: true, message: '请输入真实姓名', trigger: 'blur' },
            { min: 3, max: 25, message: '长度应为 3 至 25', trigger: 'blur' },
        ],
        email: [
            { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' },
        ],
        phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { min: 3, message: '长度应不少于3位', trigger: 'blur' },
        ],
        type: [
            {
            required: true,
            message: '请选择举报类型',
            trigger: 'change',
            },
        ],
        link: [
            { required: true, message: '请输入链接', trigger: 'blur' },
            { type: 'url', message: '请输入正确的链接', trigger: 'blur' },
        ],
        desc: [
            { required: true, message: '举报信息内容不能为空', trigger: 'blur' },
        ],
        code: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
        
    })

    const submitForm = async (formEl: FormInstance | undefined) => {
        if (!formEl) return
        await formEl.validate((valid, fields) => {
            if (valid) {
                console.log('submit!')
                saveReport(ruleForm).then( res => {
                    if (res.status == 200) {
                        // 保存成功
                        ElMessage({
                            showClose: true,
                            message: '保存成功',
                            type: 'success',
                        })

                        saveSuccess.value = true
                    } else if (res.status == 400) {
                        // 参数有误 直接提示
                        ElMessage({
                            showClose: true,
                            message: res.data.error_msg,
                            type: 'error',
                        })
                    } else if (res.status == 1000) {
                        // 验证码已过期 刷新验证码
                        ElMessage({
                            showClose: true,
                            message: '验证码已过期，请重新输入',
                            type: 'error',
                        })
                        refCode()
                    } else if (res.status === 1002) {
                        // 验证码不正确
                        ElMessage({
                            showClose: true,
                            message: '验证码输入错误',
                            type: 'error',
                        })
                    } else {
                        // 其他错误 
                        ElMessage({
                            showClose: true,
                            message: '保存失败，请稍后重试',
                            type: 'error',
                        })
                    }
                })
            } else {
                console.log('error submit!', fields)
            }
        })
    }

    const options = ref([
        {'label': '自媒体专项行动', 'value': 10},
        {'label': '垃圾广告', 'value': 1},
        {'label': '色情淫秽', 'value': 2},
        {'label': '政治反动', 'value': 3},
        {'label': '钓鱼诈骗', 'value': 4},
        {'label': '网络敲诈和有偿删帖', 'value': 5},
        {'label': '涉未成年人', 'value': 6},
        {'label': '算法问题', 'value': 7},
        {'label': '网络暴力问题', 'value': 8},
        {'label': '网络谣言、虚假信息相关', 'value': 9},
        {'label': '历史虚无主义', 'value': 11},
        {'label': '亚运会专项', 'value': 12},
        {'label': '涉企侵权', 'value': 13},
    ])

    // 上传
    const fileList = ref<UploadUserFile[]>([
        // {
        //     name: 'element-plus-logo.svg',
        //     url: 'https://element-plus.org/images/element-plus-logo.svg',
        // },
    ])

    const handleRemove: UploadProps['onRemove'] = (file, uploadFiles) => {
        console.log(file, uploadFiles)
    }

    const handlePreview: UploadProps['onPreview'] = (uploadFile) => {
        console.log(uploadFile)
    }

    const handleExceed: UploadProps['onExceed'] = (files, uploadFiles) => {
        ElMessage.warning(
            `The limit is 3, you selected ${files.length} files this time, add up to ${
            files.length + uploadFiles.length
            } totally`
        )
    }

    const beforeRemove: UploadProps['beforeRemove'] = (uploadFile, uploadFiles) => {
        return ElMessageBox.confirm(
            `确定要删除文件 ${uploadFile.name} ?`, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }
        ).then(
            () => true,
            () => false
        )
    }

    function Upload(file: any) {
        console.log(file)
    }

    const captchaInfo = reactive({
        codeImg: '',
        imgUUID: '',
    })

    const refCode = function refreshCode() {
        getCaptchaCode().then( res => {
            if (res.data && res.status == 200) {
                captchaInfo.codeImg = res.data.img
                captchaInfo.imgUUID = res.data.imgUUID
                ruleForm.imgUUID = res.data.imgUUID
            }
        })
    } 

    refCode()


return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            (_unref(saveSuccess))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_image, {
                      style: {"width":"150px","height":"150px"},
                      src: require('../../assets/success.jpeg'),
                      fit: "cover"
                    }, null, 8, ["src"]),
                    _hoisted_5,
                    _hoisted_6
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_el_form, {
                    "label-position": "right",
                    "label-width": "auto",
                    ref_key: "ruleFormRef",
                    ref: ruleFormRef,
                    model: ruleForm,
                    rules: rules,
                    class: "demo-ruleForm",
                    size: formSize.value,
                    "status-icon": ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createVNode(_component_el_divider),
                      _createVNode(_component_el_form_item, {
                        label: "真实姓名",
                        prop: "realname"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: ruleForm.realname,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.realname) = $event)),
                            placeholder: "请输入您的真实姓名"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "手机号码",
                        prop: "phone"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: ruleForm.phone,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.phone) = $event)),
                            placeholder: "请输入您的手机号码"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "电子邮箱",
                        prop: "email"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: ruleForm.email,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.email) = $event)),
                            modelModifiers: { email: true },
                            placeholder: "请输入您的电子邮箱"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _hoisted_9,
                      _createVNode(_component_el_divider),
                      _createVNode(_component_el_form_item, {
                        label: "举报类型",
                        prop: "type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select_v2, {
                            modelValue: ruleForm.type,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.type) = $event)),
                            placeholder: "请选择举报类型",
                            options: options.value
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "举报地址",
                        prop: "link"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: ruleForm.link,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.link) = $event)),
                            placeholder: "请输入您要举报的具体网址"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "举报内容",
                        prop: "content"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: ruleForm.content,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((ruleForm.content) = $event)),
                            rows: 6,
                            placeholder: "请输入举报内容",
                            type: "textarea"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "添加附件",
                        prop: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_upload, {
                            "file-list": fileList.value,
                            "onUpdate:file-list": _cache[6] || (_cache[6] = ($event: any) => ((fileList).value = $event)),
                            class: "upload-demo",
                            action: "",
                            "http-request": Upload,
                            multiple: "",
                            "on-preview": handlePreview,
                            "on-remove": handleRemove,
                            "before-remove": beforeRemove,
                            limit: 3,
                            "on-exceed": handleExceed
                          }, {
                            tip: _withCtx(() => [
                              _hoisted_10
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { type: "primary" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("选择附件")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["file-list"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: "验证码",
                        prop: "code"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            class: "code-input",
                            modelValue: ruleForm.code,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((ruleForm.code) = $event)),
                            placeholder: "验证码"
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_el_image, {
                            style: {"width":"auto","height":"40px"},
                            src: 'data:image/gif;base64,' + captchaInfo.codeImg,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (refCode()))
                          }, null, 8, ["src"]),
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (refCode()))
                          }, "换一个")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (submitForm(ruleFormRef.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("确定提交")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model", "rules", "size"])
                ]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _hoisted_12,
                _createVNode(_component_el_divider, { direction: "vertical" }),
                _hoisted_13,
                _createVNode(_component_el_divider, { direction: "vertical" }),
                _hoisted_14,
                _createVNode(_component_el_divider, { direction: "vertical" }),
                _hoisted_15
              ]),
              _hoisted_16
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})